import { render, staticRenderFns } from "./standardList.vue?vue&type=template&id=395e26a3&scoped=true"
import script from "./standardList.vue?vue&type=script&lang=js"
export * from "./standardList.vue?vue&type=script&lang=js"
import style0 from "./standardList.vue?vue&type=style&index=0&id=395e26a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395e26a3",
  null
  
)

export default component.exports